var GetGameObjectManager = function (name) {
    return this.gameObjectManagers[name];
}

export default GetGameObjectManager;